import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ImageCard from '../components/ImageCard/ImageCard';
import places from '../static/places';
import useWindowPosition from '../hook/useWindowPosition';
import DividerWithText from '../components/Utils/Divider';
import { Card, CardContent, Collapse } from '@material-ui/core';
import {
  StyledTextTitle,
  StyledTextTitleZ,
} from '../components/Utils/TextStyles';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '90vh',
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  container: {
    textAlign: 'center',
    position: 'relative',
    zIndex: '1',
  },
  cardRoot: {
    minWidth: 275,
    backgroundColor: '#e2e1e1',
    alignSelf: 'center',
    textAlign: 'center',
  },
  details: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    maxWidth: 300,
  },
  mediaPadres: {
    maxWidth: 150,
  },
  title: {
    fontSize: '2rem',
  },
  desc: {
    fontSize: '1.1rem',
  },
  image: {
    position: 'absolute',
    right: '5%',
    top: '5%',
    width: '30%',
    maxWidth: '200px',
    opacity: '0.5',
  },
}));

export default function Vestimenta() {
  const classes = useStyles();
  const checked = useWindowPosition('header');
  return (
    <>
      <div id='codigo-vestimenta'>
        <DividerWithText>B&U</DividerWithText>
        <div className={classes.container}>
          <Collapse in={checked} {...(checked ? { timeout: 1000 } : {})}>
            <img
              src={process.env.PUBLIC_URL + '/assets/ByU-071.png'}
              className={classes.image}
            />
            <Card className={classes.cardRoot} elevation={0}>
              <CardContent>
                <div style={{}}>
                  <StyledTextTitle
                    color={'#bb823f'}
                    className={classes.title}
                    style={{ textAlign: 'center' }}
                  >
                    Código de vestimenta
                  </StyledTextTitle>
                  <StyledTextTitleZ
                    color={'#006d46'}
                    style={{ textAlign: 'center' }}
                  >
                    Formal
                  </StyledTextTitleZ>
                  <div>
                    <img
                      alt={`imgVestimenta`}
                      className={classes.media}
                      src={process.env.PUBLIC_URL + '/assets/ByU-12.png'}
                      loading='lazy'
                    />
                  </div>
                </div>
                <CardContent className={classes.desc}></CardContent>
              </CardContent>
            </Card>
          </Collapse>
        </div>
      </div>
      <div id='padres-novios'>
        <DividerWithText>B&U</DividerWithText>
        <div className={classes.container}>
          <Collapse in={checked} {...(checked ? { timeout: 1000 } : {})}>
            <Card className={classes.cardRoot} elevation={0}>
              <CardContent>
                <div style={{}}>
                  <StyledTextTitle
                    color={'#bb823f'}
                    className={classes.title}
                    style={{ textAlign: 'center' }}
                  >
                    Nuestros Padres
                  </StyledTextTitle>
                  <div>
                    <img
                      alt={`imgVestimenta`}
                      className={classes.mediaPadres}
                      src={process.env.PUBLIC_URL + '/assets/novio.png'}
                      loading='lazy'
                    />
                  </div>
                  <StyledTextTitleZ
                    color={'#006d46'}
                    style={{ textAlign: 'center' }}
                  >
                    Lolita Loreto
                  </StyledTextTitleZ>
                  <div>
                    <img
                      alt={`imgVestimenta`}
                      className={classes.mediaPadres}
                      src={process.env.PUBLIC_URL + '/assets/novia.png'}
                      loading='lazy'
                    />
                  </div>
                  <StyledTextTitleZ
                    color={'#006d46'}
                    style={{ textAlign: 'center' }}
                  >
                    Martha Beleche
                  </StyledTextTitleZ>
                  <StyledTextTitleZ
                    color={'#006d46'}
                    style={{ textAlign: 'center' }}
                  >
                    &
                  </StyledTextTitleZ>
                  <StyledTextTitleZ
                    color={'#006d46'}
                    style={{ textAlign: 'center' }}
                  >
                    {' '}
                    José Gámez
                  </StyledTextTitleZ>
                </div>
                <CardContent className={classes.desc}></CardContent>
              </CardContent>
            </Card>
          </Collapse>
        </div>
      </div>
      <div id='padrinos'>
        <DividerWithText>B&U</DividerWithText>
        <div className={classes.container}>
          <Collapse in={checked} {...(checked ? { timeout: 1000 } : {})}>
            <Card className={classes.cardRoot} elevation={0}>
              <CardContent>
                <div style={{}}>
                  <StyledTextTitle
                    color={'#bb823f'}
                    className={classes.title}
                    style={{ textAlign: 'center' }}
                  >
                    Nuestros Padrinos
                  </StyledTextTitle>
                  <div>
                    <img
                      alt={`imgVestimenta`}
                      className={classes.mediaPadres}
                      src={process.env.PUBLIC_URL + '/assets/iglesia.png'}
                      loading='lazy'
                    />
                  </div>
                  <StyledTextTitleZ
                    color={'#006d46'}
                    style={{ textAlign: 'center' }}
                  >
                    Lolita Prieto
                  </StyledTextTitleZ>
                  <StyledTextTitleZ
                    color={'#006d46'}
                    style={{ textAlign: 'center' }}
                  >
                    &
                  </StyledTextTitleZ>
                  <StyledTextTitleZ
                    color={'#006d46'}
                    style={{ textAlign: 'center' }}
                  >
                    Rafael Beleche
                  </StyledTextTitleZ>
                </div>
                <CardContent className={classes.desc}></CardContent>
              </CardContent>
            </Card>
          </Collapse>
        </div>
      </div>
    </>
  );
}
